import { withStyles } from '@material-ui/styles';

import { styles } from './ArticleTypeFilterCard.style';
import FilterCardBase from './ArticleTypeFilterCard';

export default withStyles(styles)(FilterCardBase);
